export function resolveMatchGoals (match) {
  if (match.goalshome !== null && match.goalsguest !== null) {
    return { home: match.goalshome, guest: match.goalsguest }
  }
  if (match.livegoalshome !== null && match.livegoalsguest !== null) {
    return { home: match.livegoalshome, guest: match.livegoalsguest }
  }
  return null
}

export function isWinnerTeam (match, teamId) {
  const goals = resolveMatchGoals(match)
  if (!goals) return false
  if (goals.home > goals.guest) return match.fk_team_home === teamId
  if (goals.home < goals.guest) return match.fk_team_guest === teamId
  return false
}

export function isLoserTeam (match, teamId) {
  const goals = resolveMatchGoals(match)
  if (!goals) return false
  if (goals.home > goals.guest) return match.fk_team_guest === teamId
  if (goals.home < goals.guest) return match.fk_team_home === teamId
  return false
}

export function isDraw (match) {
  const goals = resolveMatchGoals(match)
  if (!goals) return false
  return goals.home === goals.guest
}

export function isMatchStarted (match) {
  return (match.goalshome !== null && match.goalsguest !== null) ||
    (match.livegoalshome !== null && match.livegoalsguest !== null)
}

export function isMatchFinished (match) {
  return match.goalshome !== null && match.goalsguest !== null
}

export function isMatchCancelled (match) {
  return match.status !== null && match.status !== undefined && match.status === 'abgebrochen'
}
